"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = announcePageTitle;
exports.PageTitleConfirmation = PageTitleConfirmation;
const react_1 = __importDefault(require("react"));
function announcePageTitle(title) {
    const el = document.getElementById('page-title-confirmation');
    el === null || el === void 0 ? void 0 : el.dispatchEvent(new window.CustomEvent('page-title', {
        detail: title
    }));
}
function PageTitleConfirmation() {
    const [docTitle, setDocTitle] = react_1.default.useState('');
    const ref = react_1.default.useRef(null);
    react_1.default.useEffect(() => {
        const el = ref.current;
        const listener = ((e) => {
            setDocTitle(e.detail);
        });
        el.addEventListener('page-title', listener);
        return () => el.removeEventListener('page-title', listener);
    }, []);
    return (react_1.default.createElement("div", { id: "page-title-confirmation", ref: ref, className: "sr-only", "aria-live": "polite" }, `Loaded page "${docTitle}"`));
}
